export class Role {
  id: number;
  title: string;
  displayTitle: string;
  heading: string;
  externalUserId: string;
  userName: string;
  isDeleted: boolean;

  constructor() {
    this.id = 0;
    this.title = '';
    this.displayTitle = '';
    this.heading = '';
    this.externalUserId = '';
    this.userName = '';
    this.isDeleted = false;
  }
}
